import React from 'react';
import { render } from 'react-dom';

import { Avatar } from '../components/Avatar/Avatar';
import { ChatBubble } from '../components/ChatBubble';

import style from '../styles/misc/ghostSnippets.scss';

import cn from 'classnames';
import { Link } from 'gatsby';

export const renderGhostChatBubbles = (
  allGhostAuthor: {
    node: {
      name: string;
      slug: string;
      profile_image: string;
      bio: string;
    };
  }[]
) => {
  const ghostChatBubbles = document.querySelectorAll('.ghostChatBubbleLeft, .ghostChatBubbleRight');
  ghostChatBubbles.forEach((chatBubble: HTMLElement, index: number) => {
    const { image } = chatBubble.dataset;
    const html = ghostChatBubbles[index].innerHTML;
    const author = allGhostAuthor.find(({ node }) => {
      return node.slug === chatBubble.classList[1]?.toLowerCase();
    });

    if (image || !author) {
      render(
        <div style={{ marginBottom: '24px' }}>
          <ChatBubble
            primaryAuthor={{ name: chatBubble.classList[1], profile_image: image }}
            isAlternate={chatBubble.classList[0] === 'ghostChatBubbleRight'}
            isAuthor={chatBubble.classList[2] === 'single'}
          >
            <div style={{ padding: '24px' }}>
              <h5 style={{ paddingTop: 0 }}>{chatBubble.classList[1]}</h5>
              <div dangerouslySetInnerHTML={{ __html: html }} />
            </div>
          </ChatBubble>
        </div>,
        ghostChatBubbles[index]
      );
    } else {
      render(
        <div style={{ marginBottom: '24px' }}>
          <ChatBubble
            primaryAuthor={author.node}
            isAlternate={chatBubble.classList[0] === 'ghostChatBubbleRight'}
            isAuthor={chatBubble.classList[2] === 'single'}
          >
            <div style={{ padding: '24px' }}>
              <Link to={`/author/${author.node.slug}/`}>
                <h5 style={{ paddingTop: 0 }}>{author.node.name}</h5>
              </Link>
              <div dangerouslySetInnerHTML={{ __html: html }} />
            </div>
          </ChatBubble>
        </div>,
        ghostChatBubbles[index]
      );
    }
  });
};

export const renderGhostInlineTOC = () => {
  const ghostInlineTOC = document.querySelectorAll('.ghostInlineTOC')[0];

  const headings: { content: string; id: string }[] = [];

  document.querySelectorAll('h1, h2, h3').forEach((val: Element) => {
    const headingRendered = document.createElement('div');
    headingRendered.innerHTML = val.innerHTML;

    if (headingRendered.textContent) {
      headings.push({ content: headingRendered.textContent.trim(), id: val.id });
    }
  });

  const handleNavClick = (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
    const id = (e.target as HTMLLIElement).dataset.id || '';
    const el = document.getElementById(id);

    if (el) {
      const bodyRect = document.body.getBoundingClientRect();
      const elemRect = el.getBoundingClientRect();
      const offset = elemRect.top - bodyRect.top - 96;

      window.scrollTo({
        behavior: 'smooth',
        top: offset,
      });
    } else {
      window.scrollTo({
        behavior: 'smooth',
        top: 0,
      });
    }
  };

  if (ghostInlineTOC) {
    render(
      <ul className={style.inlineTOC}>
        {headings.map((heading) => (
          <li data-id={heading.id} key={heading.id} onClick={handleNavClick}>
            <span className={style.marker} />
            <span className={style.text}>{heading.content}</span>
          </li>
        ))}
      </ul>,
      ghostInlineTOC
    );
  }
};

export const renderGhostAuthorAside = (
  allGhostAuthor: {
    node: {
      name: string;
      slug: string;
      profile_image: string;
      bio: string;
    };
  }[]
) => {
  const ghostAuthorAsides = document.querySelectorAll('.ghostAuthorAside');

  ghostAuthorAsides.forEach((aside: HTMLElement) => {
    if (aside) {
      let author = allGhostAuthor.find(({ node }) => {
        return node.slug === aside.classList[1];
      });

      if (!author) {
        author = { node: { profile_image: '', name: '', slug: '', bio: '' } };
      }

      render(
        <div className={style.authorAside}>
          <div className={style.author}>
            <Avatar
              className={style.image}
              profile_image={author.node.profile_image}
              name={author.node.name}
            />
            <p className={style.name}>{author.node.name}</p>
            {aside.dataset ? <p>{aside.dataset.role}</p> : null}
          </div>
          <div dangerouslySetInnerHTML={{ __html: aside.innerHTML }}></div>
        </div>,
        aside
      );
    }
  });
};

export const renderGhostImageFloat = () => {
  const ghostImageFloats = document.querySelectorAll('.ghostImageFloatLeft, .ghostImageFloatRight');

  ghostImageFloats.forEach((snippet: HTMLElement) => {
    render(
      <div
        className={cn(style.imageFloatSnippet, {
          [style.right]: snippet.classList[0] === 'ghostImageFloatRight',
        })}
        dangerouslySetInnerHTML={{ __html: snippet.innerHTML }}
      />,
      snippet
    );
  });
};
